// extracted by mini-css-extract-plugin
module.exports = {"tags":"TagPills_tags__2aeuR","edit":"TagPills_edit__Kxh50"};